import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  empty: { color: theme.palette.text.secondary },
}));

/** The muted dash a table cell shows when it has no value. */
export function EmptyCell() {
  const classes = useStyles();
  return <span className={classes.empty}>—</span>;
}
